// eslint-disable-next-line import/no-extraneous-dependencies
import { createHashHistory } from 'history';

const history = createHashHistory();

export default history;
